import { Button, Divider, Grid, Typography } from '@mui/material'
import miestudio from '../../images/LogoErreparPlus.png'
import errepar from '../../images/Iso Errepar.png'
import { Box } from '@mui/system'
import useStyles from './useStyles'
import library from '../../utils/Library'
import parser from '../../utils/Parser'

export function Login () {
  const classes = useStyles()
  const redirectLoginCross = () => {
    const urlLoginCross = parser.getDomain().includes('localhost')
      ? library.getBaseAPIUrl('localLogin')
      : library.getBaseAPIUrl('login')
    window.location.href = urlLoginCross
  }
  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.header}>
          <Box className={classes.boxheader}>
            <img src={miestudio} className={classes.img} />
          </Box>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item xs={12} className={classes.body}>
          <div className={classes.imgErreparBox}>
            <img src={errepar} className={classes.imgErrepar} />
          </div>
          <div className={classes.boxBody}>
            <div style={{ width: '100%' }}>
              <div className={classes.titleBox}>
                <Typography className={classes.title}>
                  Consola de Gestión Interna
                </Typography>
              </div>
              <div className={classes.boxsubtitle}>
                <Typography className={classes.subTitle}>
                  Inicie sesión en Errepar para gestionar
                </Typography>

                <Typography className={classes.subTitleBold}>
                  Mi Estudio Consola de Gestion Interna
                </Typography>
              </div>

              <div className={classes.boxButtonLogin}>
                <Button
                  type="button"
                  className={classes.buttonLogin}
                  onClick={redirectLoginCross}
                >
                  Iniciar sesión
                </Button>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.footer}>
          <Divider style={{ backgroundColor: 'red', height: '2%' }} />
          <Box
            style={{
              width: '70%',
              height: '98%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}
          >
            <Typography style={{ color: 'grey' }}></Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
